module.exports = __webpack_public_path__ + "static/media/coffee-beans.8a3660c3.jpg";